module.exports = __webpack_public_path__ + "static/media/BHC.54bcbb77.png";